import Home from "@/views/intranet/home/Home.vue";

export const home = {
  path: "/inicio",
  name: "Home",
  component: Home,
  meta: { requiresAuth: true },
};
